// If we have more than 2 cards show bus stops
export const BUS_STOP_THRESHOLD: number = 2;

export const EMPTY_STRING = '';

// When index is -1, it means that this activity does not have a calendar event
export const NO_CALENDAR_EVENT_ID = -1;
